import moment from 'moment'
/*import * as this.eventsjson  from 'https://www.aup.edu/sites/default/files/json/events-widget-content-new.json'
*/



import _ from 'lodash'




class CalendarFilters {

	constructor (){

		this.eventsjson = [],
		this.tagsjson = [],

		this.state = {
			events: [],
			loading: true,

		},
		this.statetid = {
			activeTid : null
		}
	}

	removeDuplicatesBy(keyFn, array) {
	  var mySet = new Set();
	  this.state.events = array.filter(function(x) {
	    var key = keyFn(x), isNew = !mySet.has(key);
	    if (isNew) mySet.add(key);
	    return isNew;
	  });
	}


	getEventsByNID(){
		var results
		if(this.statetid.activeTid != null){
			 results = this.eventsjson.filter(node => {
			 	let allTids = node.parents_id.replace(/\s/g, '').split(',')
			 	return allTids.indexOf(this.statetid.activeTid) !== -1
			})
		}
		else{
			 results = _.uniqBy(this.eventsjson, function(p){ return p.nid; });
		}
		this.state.events = results

	}

	getColorClass(tids, parentTids){
		let redTid = '77'
		let greyTid = '78'

		let allTids = tids +', '+ parentTids
		allTids = allTids.replace(/\s/g, '').split(',')

		if(allTids.indexOf(redTid) !== -1){
			return "colorRed"
		}
		else if(allTids.indexOf(greyTid) !== -1){
			return "colorGrey"
		}
		else{
			return "colorBlue"
		}


	}

	getEventsByDay(){

		var results

		let minDate = moment().add(-1, 'y').format('YYYY-MM-DD');



		if(this.statetid.activeTid != null){
			results = this.eventsjson.filter(node => {
			 	let allTids = node.parents_id.replace(/\s/g, '').split(',')
			 	return (node.dateEnd > minDate ) && ( allTids.indexOf(this.statetid.activeTid) !== -1 )
			})
		}
		else{
			results = _.uniqBy(this.eventsjson, function(p){ return p.nid; });
		}

		results = results.filter(node => {
			return node.dateEnd > minDate
		});



    var array = {}


		for(var i in results) {


		    var result = results[i];



		    if(result.dateStart != result.dateEnd){
		    	let startDate = new Date(result.dateStart)
		    	let endDate = new Date(result.dateEnd)



		    	while(startDate <= endDate){


			       let newDate = startDate.setDate(startDate.getDate() + 1);

			       startDate = new Date(newDate);

			       let pushDate = moment(startDate).subtract(1, 'day').format('YYYY-MM-DD')


			    	if(typeof array[pushDate] == 'undefined'){
				        array[pushDate] = [];
				    }

					array[pushDate].push(result);
			    }

		    }

		 	else{

		 		if(typeof array[result.dateStart] == 'undefined'){
			        array[result.dateStart] = [];
			    }

		    	array[result.dateStart].push(result)
		   }
		}

		this.state.events = array
	}

	filterByDaySingle(events, day){


		var checkDate = moment(day).format("YYYY-MM-DD")
		var niqueNID = [];

	  return events.filter(
	  	function(event){

    		if(event.dateStart == event.dateEnd && event.dateStart == checkDate) {

    			if(!niqueNID.includes(event.nid)){
    				niqueNID.push(event.nid);
    				return(event)
    			}
    		}

	  	}
	  )



	}

	filterByDayMultiple(events, start, end){


		var filteredEvents = []
		var niqueNID = [];


		for (var i = 0, len = events.length; i < len; i++) {

			let event = events[i]

			let startDate = moment(event.dateStart)
    		let endDate = moment(event.dateEnd)

    		let yearStart = moment(event.dateStart).format('Y')
    		let yearEnd = moment(event.dateEnd).format('Y')


    		if(event.nid == 4958){
    				if(  !startDate.isSame(endDate)){
    					console.log('1')
    				}

    				if( start.isBetween(startDate, endDate,'day', '[]') ){
    					console.log('2')
    				}

    				if( end.isBetween(startDate, endDate, 'day', '[]') ) {
    					console.log('3')
    				}

    				if( startDate.isBetween(start, end, 'day', '[]') ) {
    					console.log('4')

    				}

    				if( endDate.isBetween(start, end, 'day', '[]') ) {
    					console.log('5')
    				}
    		}


			if(  !startDate.isSame(endDate) && ( start.isBetween(startDate, endDate,'day', '[]') || end.isBetween(startDate, endDate, 'day', '[]') || startDate.isBetween(start, end, 'day', '[]') || endDate.isBetween(start, end, 'day', '[]') ) ){

				let dayToStart
				let dayToEnd




				if ( startDate.isSameOrBefore(start)){
					dayToStart = 0

				}
				else{
					dayToStart = startDate.diff(start, 'days');

				}

				if ( endDate.isAfter(end)){
					dayToEnd = 0;
				}
				else{
					dayToEnd = end.diff(endDate, 'days');
				}


				let numberDay = 7 - dayToStart - dayToEnd

				event['daysNum'] = numberDay;

				if(!niqueNID.includes(event.nid)){
					niqueNID.push(event.nid);
					filteredEvents.push(event)
				}

			}
		}

	   return filteredEvents.sort(
	   		function(a,b){
	   			return a.daysNum - b.daysNum
	   		}
	   	)

	}

	howManyMultiEventPerDay(events, day){
		let incr = 0

		for (var i = 0, len = events.length; i < len; i++) {

			let event = events[i]
			let startDate = moment(event.dateStart)
    		let endDate = moment(event.dateEnd)

			if(  !startDate.isSame(endDate) &&  day.isBetween(startDate, endDate,'day', '[)')  ){

				incr++

			}

		}

		return incr

	}

}

export default new CalendarFilters()



// WEBPACK FOOTER //
// ./src/components/calendar/CalendarStoreEvents.js